module.exports = __webpack_public_path__ + "img/en.a25a946f.svg";